export enum LinkType {
  EXTERNAL = 'external',
  INSTAGRAM = 'instagram',
}
